import React from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';

const ActionButton = ({
  label,
  color,
  disabled,
  size = 'md',
  selectedIds = [],
  filteredRows = [],
  validateRow, 
  onAction,    
  additionalArgs = [],
}) => {

  const handleClick = () => {
    const validRows = selectedIds.filter(id => {
    
      const row = filteredRows.find(r => r.id === id);
    
      return validateRow(row);
    });

   
      onAction(validRows, ...additionalArgs);

  };

  return (
    <Button variant="contained" color={color} size={size} onClick={handleClick} disabled={disabled}>
      {label}
    </Button>
  );
};

export default ActionButton;
